<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="BANKA.MESTO.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-dropdown-picklist
              [ModelName]="'komitent'"
              [GetName]="'get'"
              [ModelProperty]="'SNaziv,Mesto'"
              [OrderBy]="'SNaziv'"
              [AllowAddNew]="true"
              [AllowEdit]="true"
              formControlName="KomitentID"
              [Label]="'FAKDOKUMENT.KOMITENT.SINGULAR'"
              [Width]="'150%'"
              [Position]="'left'"              
              [ngClass]="{ 'is-invalid': submitted && fc.KomitentID.invalid }"
              #cmbKomitent
            >
            </yt-dropdown-picklist>
            <!-- <div class="form-error" *ngIf="submitted && fc.KomitentID.invalid">
              <span *ngFor="let validation of errorMessages.KomitentID">
                <span
                  class="error-message"
                  *ngIf="fc.KomitentID.hasError(validation.type)"
                  ><span translate="{{ validation.message }}"></span
                ></span>
              </span>
            </div> -->
          </div>
        </div>

        <div class="form-group row">
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtNazivObjekat"
              formControlName="NazivObjekta"
              #txtNaziv
              [MaxLength]="100"
              [ngClass]="{ 'is-invalid': submitted && fc.NazivObjekta.invalid }"
              [Label]="'KOMITENTOBJEKAT.NAZIVOBJEKTA.SINGULAR'"
              #autofocus
            >
            </yt-input>
            <div
              class="form-error"
              *ngIf="submitted && fc.NazivObjekta.invalid"
            >
              <span *ngFor="let validation of errorMessages.NazivObjekta">
                <span
                  class="error-message"
                  *ngIf="fc.NazivObjekta.hasError(validation.type)"
                  ><span translate="{{ validation.message }}"></span
                ></span>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtAdresa"
              formControlName="Adresa"
              [MaxLength]="150"
              [ngClass]="{ 'is-invalid': submitted && fc.Adresa.invalid }"
              [Label]="'KOMITENTOBJEKAT.ADRESA.SINGULAR'"
            >
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.Adresa.invalid">
              <span *ngFor="let validation of errorMessages.Adresa">
                <span
                  class="error-message"
                  *ngIf="fc.Adresa.hasError(validation.type)"
                  ><span translate="{{ validation.message }}"></span
                ></span>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group row" *ngIf="koristiSifarnikUlica">
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtBroj"
              formControlName="Broj"
              [MaxLength]="10"
              [Label]="'KOMITENTOBJEKAT.BROJ.SINGULAR'"
            >
            </yt-input>
          </div>
        </div>

        <div class="form-group row" *ngIf="koristiSifarnikUlica">
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtPodBroj"
              formControlName="PodBroj"
              [MaxLength]="10"
              [Label]="'KOMITENTOBJEKAT.PODBROJ.SINGULAR'"
            >
            </yt-input>
          </div>
        </div>

        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="BANKA.MESTO.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-autocomplete
              [ModelName]="'mesto'"
              [GetName]="'getByNaziv'"
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'"
              [Label]="'KOMITENTOBJEKAT.MESTO.SINGULAR'"
              [ShowHeader]="true"
              [ngClass]="{ 'is-invalid': submitted && fc.MestoID.invalid }"
              formControlName="MestoID"
              [ShowHeader] = "true"
            >
            </yt-autocomplete>

            <div class="form-error" *ngIf="submitted && fc.MestoID.invalid">
              <span *ngFor="let validation of errorMessages.MestoID">
                <span
                  class="error-message"
                  *ngIf="fc.MestoID.hasError(validation.type)"
                  ><span translate="{{ validation.message }}"></span
                ></span>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="BANKA.MESTO.SINGULAR"></span></label> -->
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtGln"
              formControlName="Gln"
              [MaxLength]="13"
              [Label]="'KOMITENTOBJEKAT.GLN.SINGULAR'"
            >
            </yt-input>

          </div>
        </div>
      </div>
    </div>
  </div>
</form>
